import { Photo } from '@resparke/models';
import { EMPTY, map, of, switchMap, tap } from 'rxjs';
import { AppStateService } from '../../app-state/app-state.service';
import { Injector } from '@angular/core';
import { FileService } from '../../files/file.service';
import { SubscriptionResponse } from '../subscription.service';

interface PhotoSubscriptionResponse {
  status: string;
  item: Photo;
}

export const handle = (injector: Injector, response: SubscriptionResponse, variables: { source: string; residentId: string, facilityId: string }) => {
  return of(response).pipe(
    map(response => {
      return response.payload
        ? (JSON.parse(response.payload) as PhotoSubscriptionResponse)
        : undefined;
    }),
    switchMap(response => {
      if (!response) {
        throw new Error('No response from photo subscription');
      }
      if (response.status === 'PHOTO_DELETED') {
        return photoDelete(injector, response);
      } else if (response.status == 'PHOTO_UPDATED') {
        return photoUpdate(injector, response);
      } else if (response.status === 'PHOTO_ADDED') {
        return photoAdd(injector, variables);
      }
      return EMPTY;
    }),

  );
}

function photoUpdate(injector: Injector, response: PhotoSubscriptionResponse) {
  const appState = injector.get(AppStateService);
  const { item } = response;


  const photos = appState.get('residentPhotos') || [];
  const updatedPhoto = photos.find(photo => photo.id === item.id);

  if (!updatedPhoto) {
    console.warn(`[PHOTO_UPDATE] Photo ${item.id} not found in local collection`);
    return EMPTY;
  }
  updatedPhoto.caption = item.caption;
  appState.set('residentPhotos', photos);
  return EMPTY;
}

function photoDelete(injector: Injector, response: PhotoSubscriptionResponse) {
  const appState = injector.get(AppStateService);
  const { item } = response;
  let photos = appState.get('residentPhotos') || [];
  const deletedPhoto = photos.find(photo => photo.id === item.id);
  if (deletedPhoto) {

    photos = photos.filter(photo => photo.id !== item.id);
    appState.set('residentPhotos', [...photos]);
  }
  return EMPTY;
}

function photoAdd(injector: Injector, variables: { residentId: string, facilityId: string }) {
  const appState = injector.get(AppStateService);
  const fileService = injector.get(FileService);
  const { residentId, facilityId } = variables;

  return fileService.getResidentPhotos({ residentId })
    .pipe(
      switchMap(photos => fileService.getPhotoObjects({ photos, facilityId, residentId })),
      tap(photos => {
        photos = photos.sort((a, b) => b.dateCreated - a.dateCreated)
        appState.set('residentPhotos', [...photos]);
      })
    )
}